import React, { useState, useEffect } from "react";

import { Table, Button, Empty, Badge, Pagination } from "antd";
import { debounce } from "lodash";
import axios from "axios";
//import OrderHistoryLoaderLayout from "../screenLoader/OrderHistoryLoaderLayout";
// import moment from 'moment';
import NoticeListScreenLoaderLayout from "../screenLoader/NoticeListScreenLoaderLayout";
import "../../styles/NotificationNavBarLayout.css";

export default function CurrentNotificationList() {

  const [currentNoticeList, setCurrentNoticeList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCurrentNotice, setTotalCurrentNotice] = useState("");
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 8;

  const base_url = process.env.REACT_APP_BASE_URL;

  const columns = [
    {
      title: "Title",
      dataIndex: "tite",
      key: "title",
      width: "4%",
      align: "left",
      // verticalAlign: "text-top",
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      align: "left",
      width: "7%",
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   width: "3%",
    //   align: "center",
    // },
    // {
    //   title: "Expired Date",
    //   dataIndex: "expiredDate",
    //   key: "expiredDate",
    //   width: "3%",
    //   align: "right",
    // },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const accessToken = sessionStorage.getItem("accessToken");
        //const user_id = sessionStorage.getItem("userData");

        const response = await axios.get(
          `${base_url}/api/v1/client/notice/list`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: {
              page: currentPage,
            },
          }
        );

        const { data } = response;
        // console.log(data)
        setCurrentNoticeList(data.data);
        // console.log(data.data.getTotalOrders
        //   )
        setTotalCurrentNotice(data.total_notices);
      } catch (error) {
        console.error(error);
      }
      finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };

    // fetchData();
    const debouncedFetchData = debounce(fetchData, 500); // Adjust the debounce delay as needed
    debouncedFetchData();
    return () => {
      // Cancel the debounced function when the component unmounts
      debouncedFetchData.cancel();
    };
  }, [base_url, currentPage]);


  const pageCount = Math.ceil(totalCurrentNotice / 8);

  const data = currentNoticeList.map((order, index) => {

    // const formattedDate = moment(order.notice_expiry_date, 'YYYY-MM-DD');
    // const weekday = formattedDate.format('dddd');
    return {
      key: index,
      tite: (
        <div>
          {order.notice_title}
        </div>
      ),
      content: order.notice_content
      ,
      // status: (
      //   <div>
      //     {order.status}

      //   </div>
      // ),
      // expiredDate: (
      //   <div >
      //     {order.notice_expiry_date}&nbsp;({weekday})
      //   </div>
      // ),
    };
  });

  const handlePaginationChange = (page) => {
    setCurrentPage(page);
    if (page < 1) {
      setCurrentPage(page + 1);
    }
    if (page > pageCount) {
      setCurrentPage(pageCount);
    }
  };

  return (

    <>
      <>
        <Badge.Ribbon
          text="New Messages"
          color="rgb(0,176,240)"
          placement="start"
        >
          {/* <h4 style={{ fontSize: "19px" }} className="text-muted"></h4> */}
        </Badge.Ribbon>
      </>
      <div style={{ marginTop: "10px", textAlign: "right" }}>
        {/* <Button
          className="notive-pagination-button"
          onClick={() => handlePaginationChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <span style={{ margin: "0 10px" }}>{currentPage}</span>

        {currentNoticeList.length > 0 && (
          <Button
            className="notive-pagination-button"
            onClick={() => handlePaginationChange(currentPage + 1)}
            disabled={currentPage === pageCount}
          >
            Next
          </Button>
        )} */}
        <Pagination
          current={currentPage}
          total={totalCurrentNotice}
          pageSize={itemsPerPage}
          onChange={handlePaginationChange}
        />
        {loading && (

          <NoticeListScreenLoaderLayout screenLoaderText="Loading Notice List..." />
        )}
      </div>

      {currentNoticeList.length > 0 && !loading ? (
        <>
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            style={{ marginTop: "30px" }}
            size="small"
          />
        </>
      ) : totalCurrentNotice === 0 && !loading ? (
        <div style={{ textAlign: "center", marginTop: "140px" }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_DEFAULT}
            description={
              <p style={{ color: "#ababab" }}>No Current Notice Found !</p>
            }
          />
        </div>
      ) : null}
    </>

  );
}
